module.exports = __webpack_public_path__ + "static/media/onboarding15.de536f13.svg";